import { useNavigate } from 'react-router-dom';
import { impactOccuer } from './hapticEvents';
import { useEffect } from 'react';

export const useTelegramBackButton = (backTo: string, enabled = true) => {
  const navigate = useNavigate();

  useEffect(() => {
    const tg = window?.Telegram?.WebApp;
    if (!tg) return;

    // Screens that are entered as a standalone flow hide the native back
    // button instead of wiring it up.
    if (!enabled) {
      tg.BackButton.hide();
      return;
    }

    const onBack = () => {
      impactOccuer('soft');
      if (backTo === '-1') {
        navigate(-1);
      } else {
        navigate(backTo);
      }
    };

    tg.BackButton.setParams?.({ is_visible: true });
    tg.BackButton.show();
    tg.onEvent('backButtonClicked', onBack);

    return () => {
      tg.offEvent('backButtonClicked', onBack);
    };
  }, [navigate, backTo, enabled]);
};

export const BackButtonHide = () => {
  if (window?.Telegram) {
    window.Telegram.WebApp.BackButton.hide();
  }
};
